import { TextStyling } from '@thg-commerce/gravity-theme/typography/typography'

export type BestSellersThemeInterface = {
  title: {
    font: TextStyling
  }
  subtitle: {
    font: TextStyling
  }
  carousel: {
    indicatorStyle: 'hidden' | 'letterbox'
  }
}

export const BEST_SELLERS_WIDGET_THEME: BestSellersThemeInterface = {
  title: {
    font: {
      entry: 'large1',
      style: 'alternate',
      textDecoration: 'none',
      transform: 'none',
      textColor: '#333333',
    },
  },
  subtitle: {
    font: {
      entry: 'bodyText',
      style: 'default',
      textDecoration: 'none',
      transform: 'none',
      textColor: '#333333',
    },
  },
  carousel: {
    indicatorStyle: 'hidden',
  },
}
